module.exports = __webpack_public_path__ + "img/lemon_meringue_pie_filling_closeup.bb05d30b.jpg";